import InfoIcon from "@mui/icons-material/Info";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Box, Tooltip, Typography } from "@mui/material";
import AddDialog from "./Dialog";

const MAX = 300;

const AddRecipient = ({ groupId, count }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
				<Button
					variant="contained"
					onClick={handleClickOpen}
					disabled={count >= MAX}
				>
					{t("add_carrier_to_mailing_group")}
				</Button>
				{count >= MAX && (
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("max_recipients_reached", { max: MAX })}
							</Typography>
						}
					>
						<InfoIcon sx={{ color: "#F07C00" }} />
					</Tooltip>
				)}
			</Box>
			<AddDialog
				open={open}
				onClose={handleClose}
				groupId={groupId}
				count={count}
			/>
		</>
	);
};

export default AddRecipient;
